/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';

import { AelDto } from './ael.dto';

export const AelMapper = entity<AelDto>({
  eventDate: date(DateFormat.DateTime),
});
